export default function StatusBadge({ status }) {
  const styles = {
    active: { background: '#c8ddd0', color: '#4a7358' },
    draft: { background: '#fef3d8', color: '#a07820' },
    archived: { background: '#ede3d5', color: '#7a5c4a' },
  };
  const s = styles[status] || styles.draft;
  return (
    <span style={{ display: 'inline-block', borderRadius: 50, padding: '3px 10px', fontSize: 11, fontWeight: 800, textTransform: 'capitalize', ...s }}>
      {status}
    </span>
  );
}
